import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    AccountClient,
    BoxResultType,
    CustomReportAccountView,
    EntityTypeCustomFieldDto,
    GetAccountColumnChartValuesResultType,
    GetAccountLineChartValuesResultType,
    GetAccountMetricsValuesResultType,
    GetAccountValuesParameters,
    GetAccountValuesResultType,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingAccountService extends CustomReportServiceBase<AccountClient, CustomReportAccountView> {
    constructor(protected override client: AccountClient) {
        super(client);
    }

    async getAccountBoxesValues(parameters: GetAccountValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.accountGetAccountBoxesValues(parameters));
    }

    async getAccountColumnChartValues(
        parameters: GetAccountValuesParameters
    ): Promise<GetAccountColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.accountGetAccountColumnChartValues(parameters));
    }

    async getAccountLineChartValues(
        parameters: GetAccountValuesParameters
    ): Promise<GetAccountLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.accountGetAccountLineChartValues(parameters));
    }

    async getAccountMetricsValues(parameters: GetAccountValuesParameters): Promise<GetAccountMetricsValuesResultType> {
        return await lastValueFrom(this.client.accountGetAccountMetricsValues(parameters));
    }

    async getAccountValues(parameters: GetAccountValuesParameters): Promise<GetAccountValuesResultType[]> {
        return await lastValueFrom(this.client.accountGetAccountValues(parameters));
    }
    override async saveCustomReport(body: CustomReportAccountView): Promise<CustomReportAccountView> {
        if (body.isPublic) return await lastValueFrom(this.client.accountSaveCatalogReport(body));
        else return await lastValueFrom(this.client.accountSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportAccountView> {
        return await lastValueFrom(this.client.accountGetCustomReport(id));
    }

    override async shareReport(body: CustomReportAccountView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.accountCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportAccountView> {
        return await lastValueFrom(this.client.accountGetSharedReport(id));
    }

    async getCustomFieldColumns(organizationIds: number[]): Promise<EntityTypeCustomFieldDto[]> {
        return await lastValueFrom(this.client.accountGetCustomFieldColumns(organizationIds));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.accountResultAvailableColumns(organizationIds));
    }
}
